export default __webpack_public_path__ + "static/media/partners-logo-transys-w@2x.bad90ded.webp";